import { jsx } from "panel";
import { SelectAllMechanism } from "common/components/items-menu/types";
import { QueryBlockEl } from "common/query-builder/query-block/panel";
import { IncludeCustomPropertyType, MenuItemType } from "common/query-builder/query-block/properties-menu/types";
import { MenuType } from "common/query-builder/query-block/types";
import { SelectorType } from "common/query-builder/query-block/constants";
export function template() {
  var _a, _b, _c, _d, _e;
  const { selected } = this.state;
  const isDataGroup = !!this.attr(`data-group-id`);
  const { t } = this.getContext(`i18n`);
  return /* @__PURE__ */ jsx(
    QueryBlockEl,
    {
      type: MenuType.Properties,
      allowBehavioralPropertyCreation: this.attr(`allow-behavioral-property-creation`) || true,
      minSelection: this.attr(`allow-zero-selections`) ? 0 : 1,
      searchPlaceholder: t(`users.search-props`),
      projectId: (_a = this.attr(`project-id`)) != null ? _a : void 0,
      selected,
      label: `${t(`events.actions.edit-columns`)} \u2022 ${this.attr(`selected-properties`).length}`,
      selectorIcon: `edit`,
      selectorType: SelectorType.Button,
      hideEvents: true,
      multiple: true,
      includeCustomProperties: IncludeCustomPropertyType.All,
      inputOnly: true,
      workspaceId: (_b = this.attr(`workspace-id`)) != null ? _b : void 0,
      allDataGroups: isDataGroup,
      dataGroupId: (_c = this.attr(`data-group-id`)) != null ? _c : void 0,
      projectHasPeople: !isDataGroup,
      hideRecentlyViewed: true,
      hideEditControls: (_d = this.attr(`hide-edit-controls`)) != null ? _d : void 0,
      excludeDimensionProperties: true,
      showSelectAll: true,
      selectAllMechanism: SelectAllMechanism.Partial,
      trackName: "users",
      selectableSensitiveProperties: true,
      theme: (_e = this.attr(`theme`)) != null ? _e : void 0,
      menuItemTypes: [MenuItemType.UserProperties],
      onSelect: this.helpers.handleQueryBlockSelect,
      onClose: this.helpers.handleQueryBlockClose,
      getSortedMenuSections: this.helpers.getSortedMenuSections
    }
  );
}
